import { createSlice,createAsyncThunk } from '@reduxjs/toolkit';
import api from '../helper/Api';

const initialState = {
  users: [], // List of users on the left side
  activeUser: null, // The user currently chatting with on the right side
  messages: [],
  admins:[],
  isLoading:false,// Chat messages, keyed by user ID
  isChatloading:false
};


export const getusersChat=createAsyncThunk('get-history',async (body, { rejectWithValue, dispatch }) => {
   try {
    dispatch(setLoading(true))

    const {data,status} = await api.getChatHistory(body)

    if(status === 200){
        dispatch(setUsers(data.data))
        console.log(data,"daza");
        
    } 
    
    
    
   } catch (err) {
    dispatch(setLoading(false))
//         Toastify.error(err.response.data.message);
         return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
   }finally{
    dispatch(setLoading(false))
   }
})


export const getAllChats=createAsyncThunk('get-chats',async(body,{rejectWithValue, dispatch})=>{
    try {

          console.log("hitting get all chats");
          
        dispatch(setChatLoading(true))
        const {data,status}=await api.getChats(body)

        console.log(data,"messageData");
        

        if(status === 200){
          dispatch(setMessages(data.data))
        }

        
    } catch (err) {
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")

    }finally{
      dispatch(setChatLoading(true))
    }
})


export const getAllActiveAdmins=createAsyncThunk('get-admins',async(body,{rejectWithValue, dispatch})=>{
  try {

    console.log("ghrtdsgdvh");
    
    const {data,status} = await api.getActiveAdmins()


    console.log(data,"admins");
    
    if(status === 200){
      dispatch(setAdmins(data.data))
    }

    

  } catch (err) {
    console.log(err,"eroor");
    
    return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")

  }
})


export const createMessage=createAsyncThunk('add-message',async(body,{rejectWithValue, dispatch})=>{
 
  try {

        const {data,status} = await api.addMessage(body)

        if(status === 200){
          dispatch(getusersChat(""))
        }
    
  } catch (err) {
    return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")

  }
})



const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
     },
    setLoading:(state,action)=>{
        state.isLoading=action.payload
    },
    setChatLoading:(state,action)=>{
        state.isChatloading=action.payload
    },
    setActiveUser: (state, action) => {
      state.activeUser = action.payload;
    },
    setAdmins:(state,action)=>{
      state.admins = action.payload
    },
    addMessage: (state, action) => {
      const { userId, message } = action.payload;
      if (!state.messages[userId]) {
        state.messages[userId] = [];
      }
      state.messages[userId].push(message);
    },
    // updateChatHistories: (state, action) => {
    //   const { userId, lastMessage, lastMessageTime } = action.payload;
    //   const user = state.users.find((user) => user.userId === userId);
    //   if (user) {
    //     user.lastMessage = lastMessage;
    //     user.lastMessageTime = lastMessageTime;
    //   }
    // },
    updateChatHistories: (state, action) => {
      const { userId, lastMessage, lastMessageTime ,read} = action.payload;
    
      // Find the user in the users list
      const userIndex = state.users.findIndex((user) => user.userId === userId);
    
      if (userIndex !== -1) {
        // Update the user's last message and time
        state.users[userIndex].lastMessage = lastMessage;
        state.users[userIndex].lastMessageTime = lastMessageTime;
        state.users[userIndex].read = read;
    
    
        // Move the updated user to the first index
        const updatedUser = state.users.splice(userIndex, 1)[0];
        state.users.unshift(updatedUser);
      }
    },
    addNewChatHistory:(state,action)=>{
      state.users = [action.payload, ...state.users];
    },
    addClientMessage: (state, action) => {
      state.messages.push(action.payload); // Directly appends the new message
    },
    updateReadStatus: (state, action) => {
      const { userId, read } = action.payload;

      const userIndex = state.users.findIndex((user) => user.userId === userId);

      if (userIndex !== -1) {
        state.users[userIndex].read = read;

        // const updatedUser = state.users.splice(userIndex, 1)[0];
        // state.users.unshift(updatedUser);
      }
    },
  },
});

export const { setUsers, setActiveUser, addMessage, updateChatHistories,setLoading ,setChatLoading ,setMessages,addNewChatHistory,addClientMessage,setAdmins,updateReadStatus} = chatSlice.actions;
export default chatSlice.reducer;

